import { Column } from "react-table";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { TableCustomCell } from "../../component/table/components/TableCustomCell";
// import { IOrganization } from "../models/LogModels";
import { formatDateAdvanceToString } from "../../utils/FormatUtils";

export const COLUMNS: ReadonlyArray<Column<any>> = [
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="STT"
        className="text-center text-light spaces W-40"
      />
    ),
    id: "stt",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center "
        data={props.data[props.row.index].stt}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Tên phòng khám"
        className="text-center text-light spaces min-w-200"
      />
    ),
    id: "requestReceivingUnitName",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].requestReceivingUnitName}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Bệnh nhân"
        className="text-center text-light spaces min-w-100"
      />
    ),
    id: "patientName",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].patientName}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Dịch vụ"
        className="text-center text-white align-middle bg-pri min-w-100px"
      />
    ),
    id: "serviceName",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].serviceName}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Thời gian gửi yêu cầu"
        className="text-center text-white align-middle bg-pri spaces min-w-50"
      />
    ),
    id: "requestTime",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center"
        data={formatDateAdvanceToString(props.data[props.row.index].requestTime)}
      />
    ),
  },
];

export const PROCESS_COLUMNS: ReadonlyArray<Column<any>> = [
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="STT"
        className="text-center text-light spaces W-40"
      />
    ),
    id: "stt",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center "
        data={props.data[props.row.index].stt}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Tin nhắn"
        className="text-center text-light spaces min-w-200"
      />
    ),
    id: "message",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].message}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Thời gian xử lý"
        className="text-center text-white align-middle bg-pri spaces min-w-50"
      />
    ),
    id: "processTime",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center"
        data={formatDateAdvanceToString(props.data[props.row.index].processTime)}
      />
    ),
  },
];